// src/data/sentenceClozeProgressStorage.js
import { supabase } from "../supabaseClient";

const TABLE = "sentence_cloze_progress";

/**
 * Lädt den correct_count für (user_id, profile_id, language_id, pace).
 * Mit weekIndex: nur diese Woche (jede Woche zählt für sich, kein Vorarbeiten).
 * Ohne weekIndex: Summe über alle Wochen (bisheriges Verhalten, für ältere Aufrufer).
 *
 * Gibt 0 zurück, wenn noch kein Eintrag existiert oder ein Fehler auftritt.
 */
export async function loadSentenceClozeProgress(
  userId,
  profileId,
  languageId,
  pace,
  weekIndex
) {
  if (!userId) return 0;

  let query = supabase
    .from(TABLE)
    .select("correct_count")
    .eq("user_id", userId)
    .eq("profile_id", profileId)
    .eq("language_id", languageId)
    .eq("pace", pace);
  if (weekIndex) query = query.eq("week_index", weekIndex);

  const { data, error } = await query;

  if (error) {
    console.warn("sentenceClozeProgress: load error", error);
    return 0;
  }

  return (data || []).reduce(
    (sum, row) =>
      sum + (typeof row.correct_count === "number" ? row.correct_count : 0),
    0
  );
}

/**
 * Speichert (per upsert) den correct_count für
 * (user_id, profile_id, language_id, pace, week_index).
 */
export async function saveSentenceClozeProgress(
  userId,
  profileId,
  languageId,
  pace,
  correctCount,
  weekIndex = 1
) {
  if (!userId) return;

  const { error } = await supabase.from(TABLE).upsert(
    {
      user_id: userId,
      profile_id: profileId,
      language_id: languageId,
      pace,
      week_index: weekIndex,
      correct_count: correctCount,
      updated_at: new Date().toISOString(),
    },
    {
      onConflict: "user_id,profile_id,language_id,pace,week_index",
    }
  );

  if (error) {
    console.warn("sentenceClozeProgress: save error", error);
  }
}

/**
 * Setzt den correct_count für (user, profile, language, pace) in allen Wochen auf 0.
 */
export async function resetSentenceClozeProgress(
  userId,
  profileId,
  languageId,
  pace
) {
  if (!userId) return;

  const { error } = await supabase
    .from(TABLE)
    .update({ correct_count: 0, updated_at: new Date().toISOString() })
    .eq("user_id", userId)
    .eq("profile_id", profileId)
    .eq("language_id", languageId)
    .eq("pace", pace);

  if (error) {
    console.warn("sentenceClozeProgress: reset error", error);
  }
}
